import get from 'lodash.get';

import {
  PLAN_ADVANCED,
  PLAN_GUEST,
  PLAN_PROFESSIONAL,
  PLAN_STANDARD,
  STATUS_AUTHENTICATED,
  STATUS_INITIAL,
} from '../../../constants/app';

import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectUserData = createDeepEqualSelector(selectAuth, (auth) => auth.user);

export const selectApiKey = createDeepEqualSelector(selectUserData, (user) => get(user, 'apiKey', ''));

export const selectEmail = createDeepEqualSelector(selectUserData, (user) => get(user, 'email', ''));

export const selectFirstName = createDeepEqualSelector(selectUserData, (user) => get(user, 'firstName', ''));

export const selectLastName = createDeepEqualSelector(selectUserData, (user) => get(user, 'lastName', ''));

export const selectUuid = createDeepEqualSelector(selectUserData, (user) => get(user, 'uuid', ''));

export const selectPlan = createDeepEqualSelector(selectUserData, (user) => get(user, 'plan', ''));

export const selectStatus = createDeepEqualSelector(selectUserData, (user) => get(user, 'status'));

export const selectIsStatusInitial = createDeepEqualSelector(selectStatus, (status) => status === STATUS_INITIAL);

export const selectIsAuthenticated = createDeepEqualSelector(selectStatus, (status) => status === STATUS_AUTHENTICATED);

export const selectLoading = createDeepEqualSelector(selectUserData, (user) => get(user, 'loading'));

export const selectIsUserGuest = createDeepEqualSelector(selectPlan, (plan) => plan === PLAN_GUEST);

export const selectIsUserStandard = createDeepEqualSelector(
  [selectIsAuthenticated, selectPlan],
  (isAuthenticated, plan) => isAuthenticated && plan === PLAN_STANDARD,
);
export const selectIsUserAdvanced = createDeepEqualSelector(
  [selectIsAuthenticated, selectPlan],
  (isAuthenticated, plan) => isAuthenticated && plan === PLAN_ADVANCED,
);
export const selectIsUserProfessional = createDeepEqualSelector(
  [selectIsAuthenticated, selectPlan],
  (isAuthenticated, plan) => isAuthenticated && plan === PLAN_PROFESSIONAL,
);

export const selectUserPlans = createDeepEqualSelector(
  [selectIsUserGuest, selectIsUserStandard, selectIsUserAdvanced, selectIsUserProfessional],
  (isUserGuest, isUserStandard, isUserAdvanced, isUserProfessional) => ({
    isUserGuest,
    isUserStandard,
    isUserAdvanced,
    isUserProfessional,
  }),
);

export const selectIsUserPaying = createDeepEqualSelector(selectUserPlans, (userPlans) => {
  const { isUserAdvanced, isUserProfessional } = userPlans;

  if (isUserAdvanced || isUserProfessional) {
    return true;
  }

  return false;
});
